import { Module, ActionContext, Plugin } from 'vuex';
import { cloneDeep } from 'lodash';
import { claims } from '@growmark/cognito-vue';
import { getAffiliation } from '../../services/api';

const initial = {
  identity: undefined as unknown as UserClaims,
  affiliation: null as string | null
};

export const actions = {
	identity: async ({ commit }: UserActionContext) : Promise<void> => {
    const identity = await claims;
		commit('IDENTITY', identity);
	},
  affiliation: async({ commit }: UserActionContext): Promise<void> => {
    try {
      const data = await getAffiliation();
      commit('AFFILIATION', data);
    } catch (error) {
      console.log('Error fetching affiliation:', error);  
    }
  }
};

export const getters = {
	name: (state: State) : string => {
		return state.identity && state.identity.name ? state.identity.name : "N/A";
	},
	email: (state: State) : string => {
		return state.identity && state.identity.email ? state.identity.email : "";
	},
};

export const mutations = {
	IDENTITY: (state: State, identity: UserClaims) : void => {
		state.identity = identity
	},
	AFFILIATION: (state: State, affiliation: string) : void => {
		state.affiliation = affiliation;
	}
};

type UserClaims = Awaited<typeof claims>;

export const NAMESPACE = 'user';
type UserActionContext = ActionContext<State, MinimalRootState>;

export const plugin: Plugin<MinimalRootState> = async store => {
  store.dispatch(`${NAMESPACE}/identity`);
};

export const module: Module<State, MinimalRootState> = {
	namespaced: true,
	state: cloneDeep(initial),
	getters,
	mutations,
	actions
};

type MinimalRootState = object;
export type State = typeof initial;
export type Actions = typeof actions;
export type Getters = typeof getters;
export type Mutations = typeof mutations;